// client/src/api/endpoints/index.ts
import { departmentEndpoints } from './departments';
import { organizationEndpoints } from './organizations';
import { userEndpoints } from './users';

// Define the full structure type explicitly
interface ApiEndpoints {
  COMMON: {
    energy: {
      onsite: string;
      external: string;
      energysource: string;
    };
    technology: {
      hvac: string;
      lighting: string;
      waterpump: string;
      waterheater: string;
      cooking: string;
      monitor: string;
      plugload: string;
      sportsarenaequipment: string;
      abattoirequipment: string;
      medicalequipment: string;
    };
  };
  CONSTANTS: {
    sectors: string;
    technologyCategories: {
      all: string;
      buildings: string;
    };
    buildingUsages: string;
    areaUnits: string;
    energySources: string;
  };
  DEPARTMENTS: typeof departmentEndpoints;
  ORGANIZATIONS: typeof organizationEndpoints;
  USERS: typeof userEndpoints;
}

// Create and export the properly typed constant
export const API_ENDPOINTS: ApiEndpoints = {
  COMMON: {
    energy: {
      onsite: '/api/data/common/energy/onsite/',
      external: '/api/data/common/energy/external/',
      energysource: '/api/data/common/energy/energysource/',
    },
    technology: {
      hvac: '/api/data/common/technology/hvac/',
      lighting: '/api/data/common/technology/lighting',
      waterpump: '/api/data/common/technology/waterpump',
      waterheater: '/api/data/common/technology/waterheater',
      cooking: '/api/data/common/technology/cooking/',
      monitor: '/api/data/common/technology/sensors',
      plugload: '/api/data/common/technology/plugload/',
      sportsarenaequipment: '/api/data/common/technology/sportsarenaequipment/',
      abattoirequipment: '/api/data/common/technology/abattoirequipment/',
      medicalequipment: '/api/data/common/technology/medicalequipment/',
    },
  },
  CONSTANTS: {
    sectors: '/api/data/constant/sectors/',
    technologyCategories: {
      all: '/api/data/constant/technology_categories/all/',
      buildings: '/api/data/constant/technology_categories/buildings/',
    },
    buildingUsages: '/api/data/constant/building_usages/',
    areaUnits: '/api/data/constant/area_units/',
    energySources: '/api/data/constant/energy_sources/',
  },
  DEPARTMENTS: departmentEndpoints,
  ORGANIZATIONS: organizationEndpoints,
  USERS: userEndpoints,
} as const;
